import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on every navigation except when there's a #hash
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
    // Handle contact section scroll if needed
    else if (location.pathname === '/' && location.hash === '#contacto') {
      setTimeout(() => {
        document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  return null;
}
